<template>
	<div class="order-stage">
		<div class="flex align-items margin-bottom small-padding-bottom">
			<h1>Uniconta state: {{ unicontaState }}</h1>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    data: {},
    loading: false
  }),
  computed: {
    unicontaState () {
      if (undefined === this.data.isEligibleToInvoice) {
        return ''
      }
      if (this.data.isEligibleToInvoice) {
        return 'Invoice'
      }
      return 'Sales Order'
    }
  },
  methods: {
    loadState () {
      Vue.api.get('/order/' + this.id + '/state?name=isEligibleToInvoice', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.data = data
      })
    }
  },
  created () {
    this.loadState()
  }
}
</script>
